import { FaTimes } from 'react-icons/fa';
import { ConfigButton, ConfigText, ConfigImage, ConfigAlert, ConfigSpace, 
    ConfigMetrics, ConfigVideo, ConfigLoading, ConfigPrice, 
    ConfigQuiz, ConfigTestimonial, ConfigForm, ConfigLevels, ConfigCards, ConfigScript } from './blocksPanel';

export default function StepBlockConfigPanel({
    blocks,
    setBlocks,
    node,
    onNodeChange,
    configPanelBlock, 
    editingBlock,
    setEditingBlock,
    setBlockAsEditingBlock,
    setConfigPanelOpen,
    updateBlock,
    nodes,
    updateNode
}) {

    

    let blockConfigComponent = null;
    if (editingBlock?.type === 'text') {
        blockConfigComponent = <ConfigText block={editingBlock} setEditingBlock={setEditingBlock} updateBlock={updateBlock} />;
    } else if (editingBlock?.type === 'image') {
        blockConfigComponent = <ConfigImage block={editingBlock} setEditingBlock={setEditingBlock} updateBlock={updateBlock} />;
    } else if (editingBlock?.type === 'button') {
        
        blockConfigComponent = <ConfigButton block={editingBlock} updateBlock={updateBlock} nodes={nodes} node={node} updateNode={updateNode} />;
    } else if (editingBlock?.type === 'alert') {
        blockConfigComponent = <ConfigAlert block={editingBlock} setEditingBlock={setEditingBlock} updateBlock={updateBlock} />;
    } else if (editingBlock?.type === 'space') {
        blockConfigComponent = <ConfigSpace block={editingBlock}  />;
    } else if (editingBlock?.type === 'metrics') {
        blockConfigComponent = <ConfigMetrics block={editingBlock} updateBlock={updateBlock} />;
    } else if (editingBlock?.type === 'levels') {
        blockConfigComponent = <ConfigLevels block={editingBlock} updateBlock={updateBlock} />;
    }else if (editingBlock?.type === 'video') {
        blockConfigComponent = <ConfigVideo block={editingBlock} updateBlock={updateBlock}  />;
    } else if (editingBlock?.type === 'loading') {
        blockConfigComponent = <ConfigLoading block={editingBlock} updateBlock={updateBlock} nodes={nodes} node={node} updateNode={updateNode} />;
    } else if (editingBlock?.type === 'cards') {
        blockConfigComponent = <ConfigCards block={editingBlock} updateBlock={updateBlock} />;
    }
    else if (editingBlock?.type === 'price') {
        blockConfigComponent = <ConfigPrice block={editingBlock} updateBlock={updateBlock} />;
    }
    else if (editingBlock?.type === 'quiz') {
        blockConfigComponent = <ConfigQuiz block={editingBlock} setEditingBlock={setEditingBlock} updateBlock={updateBlock} nodes={nodes} node={node} updateNode={updateNode} />;
    }
    else if (editingBlock?.type === 'testimonial') {
        blockConfigComponent = <ConfigTestimonial block={editingBlock} updateBlock={updateBlock} />;
    }
    else if (editingBlock?.type === 'form') {
        blockConfigComponent = <ConfigForm block={editingBlock} updateBlock={updateBlock} />;
    }
    else if (editingBlock?.type === 'script') {
        blockConfigComponent = <ConfigScript block={editingBlock} updateBlock={updateBlock} />;
    }
    return (
        <div className="flex flex-col h-full w-full p-4">
            {/* Header */}
            <div className="mb-4 flex justify-between items-center">
                <h2 className="text-lg font-bold text-gray-700">
                    Editar bloco {editingBlock?.type || ''}
                </h2>
                
                <button
                    className="bg-white  text-blue-600 rounded p-2 shadow"
                    onClick={() => setConfigPanelOpen(false)}
                >
                    <FaTimes />
                </button>
            </div>
            {/* Main editing area */}
            <div className="flex flex-col gap-6 w-full overflow-y-auto"  >
                <div>
                    {blockConfigComponent}
                </div>
            </div>
        </div>
    );
}